const AdminInpPanel = () => {
    return(
        <>
        inp panel
        </>
    )
};
export default AdminInpPanel;